// extracted by extract-css-chunks-webpack-plugin
module.exports = {"note":"note__note--3Ul42","lighter":"note__lighter--wNtj-","center":"note__center--3Eo0H"};